import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageCircle, Clock } from 'lucide-react';
const SUPPORT_EMAIL = 'elementaldealsandshop@gmail.com';
export function Support() {
  return <section id="soporte" className="py-24 md:py-32 relative overflow-hidden border-t border-gold/10" data-id="element-313">
      {/* Cinematic background glow */}
      <div className="absolute inset-0 bg-black-100/30" data-id="element-314">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[600px] bg-[radial-gradient(ellipse_at_center,rgba(212,175,122,0.12)_0%,transparent_65%)] blur-3xl pointer-events-none" data-id="element-315"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-316">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative" data-id="element-317">
          {/* Glow underneath card */}
          <div className="absolute -inset-px bg-gradient-to-br from-gold/30 via-gold/5 to-transparent rounded-sm blur-md opacity-50 pointer-events-none" data-id="element-318"></div>

          <div className="relative bg-gradient-to-br from-black-100 to-black border border-gold/20 rounded-sm overflow-hidden shadow-2xl" data-id="element-319">
            {/* Top hairline */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" data-id="element-320"></div>

            <div className="grid lg:grid-cols-2 gap-0" data-id="element-321">
              {/* LEFT: Text */}
              <div className="p-10 md:p-14 lg:p-16 lg:border-r lg:border-gold/10" data-id="element-322">
                <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-6" data-id="element-323">
                  Soporte · Estamos aquí
                </p>
                <h2 className="font-display text-3xl md:text-5xl text-cream mb-6 leading-[1.05]" data-id="element-324">
                  ¿Necesitas <span className="text-gold italic" data-id="element-325">ayuda?</span>
                </h2>
                <p className="text-cream/65 text-base md:text-lg font-light leading-[1.7] mb-8" data-id="element-326">
                  Nuestro equipo está disponible para resolver cualquier duda
                  antes o después de tu compra. No importa si es sobre el
                  acceso, los prompts, o si quieres recomendaciones para tu
                  negocio — escríbenos y te respondemos personalmente.
                </p>

                <div className="space-y-4" data-id="element-327">
                  <div className="flex items-center gap-4 text-cream/70 text-sm" data-id="element-328">
                    <div className="w-9 h-9 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-329">
                      <Clock size={14} className="text-gold" data-id="element-330" />
                    </div>
                    <span data-id="element-331">Respuesta promedio en menos de 24 horas</span>
                  </div>
                  <div className="flex items-center gap-4 text-cream/70 text-sm" data-id="element-332">
                    <div className="w-9 h-9 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0" data-id="element-333">
                      <MessageCircle size={14} className="text-gold" data-id="element-334" />
                    </div>
                    <span data-id="element-335">Atención humana y personalizada</span>
                  </div>
                </div>
              </div>

              {/* RIGHT: Email CTA */}
              <div className="p-10 md:p-14 lg:p-16 bg-gradient-to-br from-black to-black-200 flex flex-col justify-center relative overflow-hidden" data-id="element-336">
                {/* Subtle inner glow */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(212,175,122,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-337"></div>

                <div className="relative z-10" data-id="element-338">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 mb-8 shadow-[0_0_30px_rgba(212,175,122,0.2)]" data-id="element-339">
                    <Mail size={24} className="text-gold" data-id="element-340" />
                  </div>

                  <p className="text-[10px] uppercase tracking-[0.3em] text-cream/50 mb-4" data-id="element-341">
                    Soporte directo
                  </p>

                  <h3 className="font-display text-2xl md:text-3xl text-cream mb-6 leading-tight" data-id="element-342">
                    Escríbenos cuando lo necesites
                  </h3>

                  <p className="text-cream/60 font-light leading-relaxed mb-8 max-w-sm" data-id="element-343">
                    Haz clic en el botón y se abrirá tu cliente de correo con
                    todo listo para enviarnos tu mensaje.
                  </p>

                  <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 px-7 py-4 bg-gold text-black rounded-sm text-xs uppercase tracking-widest font-medium hover:bg-gold-light shadow-[0_0_20px_rgba(212,175,122,0.2)] hover:shadow-[0_0_30px_rgba(212,175,122,0.4)] transition-all" data-id="element-344">
                    <Mail size={14} data-id="element-345" />
                    Enviar correo
                  </a>
                </div>
              </div>
            </div>

            {/* Bottom hairline */}
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-346"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}